import type { ButtonProps } from '@bambi/component-library/src/components/Button';
import { Button } from '@bambi/component-library/src/components/Button';
import { classNames } from '@bambi/component-library/src/utils/classNames';
import {
  FolderArrowDownIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';

type ManageCellItem = Omit<ButtonProps, 'children'> & {
  label: string;
  icon: 'pencil' | 'trash' | 'download';
  iconClassName?: string;
};

interface ManageCellProps {
  items: ManageCellItem[];
}

/**
 * A component that renders a list of manage cell items.
 */
export function ManageCell({ items }: ManageCellProps) {
  return (
    <div className="flex flex-row items-center justify-end">
      {items.map((item) => (
        <Button
          key={item.label}
          dataTestId={`manage-cell-${item.label}`}
          variant="icon"
          ariaLabel={item.label}
          onClick={item.onClick}
          {...item}
        >
          <div
            className="flex flex-col items-center text-xs"
            style={{ fontSize: '0.625rem' }}
          >
            <ManageCellIcon
              icon={item.icon}
              iconClassName={item.iconClassName}
            />
            {item.label}
          </div>
        </Button>
      ))}
    </div>
  );
}

const manageCellIconMap = {
  pencil: PencilIcon,
  trash: TrashIcon,
  download: FolderArrowDownIcon,
};

function ManageCellIcon({
  icon,
  iconClassName,
}: {
  icon: ManageCellItem['icon'];
  iconClassName?: string;
}) {
  const Icon = manageCellIconMap[icon];
  return (
    <Icon className={classNames('mt-1 h-[20px] w-[24px]', iconClassName)} />
  );
}
